import {FC} from 'react';

import {Typography} from '@mui/material';
import {t} from 'i18next';

import {StyledBasketSuccessBanner} from '../styled';

export interface BasketShippingFeeDiscountBannerProps {
  discountAmount?: number;
}

export const BasketShippingFeeDiscountBanner: FC<BasketShippingFeeDiscountBannerProps> = ({discountAmount}) => {
  if (!discountAmount) {
    return null;
  }
  return (
    <StyledBasketSuccessBanner>
      <Typography
        component={'p'}
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('message.gotShippingFeePromotion', {promotionAmount: discountAmount})
        }}
      />
    </StyledBasketSuccessBanner>
  );
};

BasketShippingFeeDiscountBanner.displayName = 'BasketShippingFeeDiscountBanner';
